import { Component, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@openng/optimus-ui/button';
import { InputTextModule } from '@openng/optimus-ui/inputtext';

import { DescriptionComponent } from '@app/shared/components/description/description.component';
import { DialogBoxComponent } from '@app/shared/components/dialog-box/dialog-box.component';
import { InputContainerComponent } from '@app/shared/components/input-container/input-container.component';

/**
 * Used for logging the user's comment for non-workflowable
 * object types. e,g. table-details, approval-workflow
 */
@Component({
    selector: 'cor-edit-change-log',
    templateUrl: './edit-change-log.component.html',
    imports: [
        FormsModule,
        DialogBoxComponent,
        InputTextModule,
        InputContainerComponent,
        DescriptionComponent,
        ButtonModule,
    ],
})
export class EditChangeLogComponent {
    readonly visible = model(false);

    confirmEvent = output<{ versionName: string; comment: string }>();

    comment: string = null;

    versionName: string = null;

    protected confirmAction() {
        this.confirmEvent.emit({ versionName: this.versionName, comment: this.comment });
        this.closePopup();
    }

    protected closePopup() {
        this.comment = null;

        this.versionName = null;

        this.visible.set(false);
    }
}
